/**
 * @flow
 */

import styled from 'react-emotion'

import { IcChevronRight } from '../../../Icons/IcChevronRight'
import { BaseDinDemi } from '../../../themes/Fonts/Din2014'
import colors from '../../../themes/Colors'

export const ButtonTextWithIconContainer = styled('a')`
  display: flex;
  align-items: baseline;
  justify-content: center;
  pointer-events: none;
`

export const ButtonText = styled(BaseDinDemi)`
  font-size: 0.875em;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.whiteTwo};
  margin-right: 0.625em;
  @media (max-width: 767px) {
    font-size: 14px;
    margin-right: 0.714em;
  }
`

export const ArrowIcon = styled(IcChevronRight)`
  display: flex;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ButtonTextWithIcon/styledComponents.js